import http from './http-common';
import axios from 'axios';
import storage from '../factory/StorageFactory';

const get = (sId) => {  
    
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }
       
    let stateId;
    if(sId) {
        stateId=sId;
    }
    else {
        stateId = storage.getStateId();
    }
    // return axios.get(`http://localhost:3000/CompDtls.json`); 
   return http.get(`/api/v1/SMEDL/getCompanyDetailsForm/${stateId}`,headerParams); 
};

const post = (params) => {
  
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
      
    return http.post(`api/v1/SMEDL/postCompanyDetailsForm`,params,headerParams);
};
 
export default {
    get,
    post
};


